module.exports = __webpack_public_path__ + "img/Chongqing-power.530d4213.png";